"use client";
import Link from "@/components/Link";
import React, { useEffect, useState } from "react";
import { Text, Box, Columns, Row } from "@dxp-feed/ui";
import { SiteContainer } from "@/components/Container";
import { useAppSelector } from "@/utils/hooks/reactUseCustomHooks";
import {
  addDataLayer,
  addDataLayerPersistantbanner,
} from "@/helpers/dataLayer";
import { generateNonce } from "@/helpers/noncehelper";

export default function HeaderTopBar() {
  const [isClosed, setIsClosed] = useState(false);
  const [alertData, setAlertData] = useState<any>(null);
  const { data: selectedStore } = useAppSelector(
    (state) => state.selectedStore
  );
  const { isLoading: isloading } = useAppSelector((state) => state.gigyaslice);

  useEffect(() => {
    if (typeof window != "undefined") {
      const isBannerClosed = sessionStorage.getItem("alertBannerClosed");
      if (isBannerClosed === "true") {
        setIsClosed(true);
      }
    }
  }, []);

  useEffect(() => {
    const fetchAlert = async () => {
      try {
        const response = await fetch(
          `/api/bannerAlert?province=${(selectedStore as any)?.address?.province || "ON"}`,
          {
            headers: {
              "x-nonce-token": generateNonce(),
            },
          }
        );
        const { data } = await response.json();
        if (response.ok) {
          setAlertData(data.getAlert[0]);
        }
      } catch (error) {
        console.error("Failed to fetch alert:", error);
      }
    };
    if ((selectedStore as any)?.address) {
      fetchAlert().catch(() => { });
    }
  }, [selectedStore]);

  useEffect(() => {
    if (!isloading) {
      if (alertData) {
        addDataLayerPersistantbanner({
          event: "popup_view",
          popup_name: `${alertData.descriptionText}`,
        });
      }
    }
  }, [alertData]);

  const handleClick = () => {
    setIsClosed(true);
    sessionStorage.setItem("alertBannerClosed", "true");
  };

  if (isClosed || !alertData) return null;

  return (
    <Box
      as="div"
      role="alert"
      aria-live="assertive"
      className="alert-top-bar py-[14px] md:py-[2px] bg-red300"
    >
      <SiteContainer>
        <Row>
          <Columns className="col-12">
            <Box
              as="div"
              className="alert-bar-inner flex items-center justify-between"
            >
              <p className="text-brandWhite text-sm md:text-body lg:text-base font-[700] leading-normal mb-0 custom-max-sm:pe-[28px] md:pe-[0]">
                {alertData.descriptionText ||
                  "Severe weather ahead! Keep track of real-time flood alerts in your area."}
              </p>
              <Box as="div" className="view-details-alert flex items-center">
                {alertData.ctaUrl && (
                  <Link
                    href={alertData?.ctaUrl || "#"}
                    className="text-brandWhite text-[14px] font-[700] leading-normal underline py-3 pl-[12px] pr-[6px] whitespace-nowrap hover:no-underline"
                    aria-label={alertData.ctaLabel || "View Details"}
                    onClick={() => {
                      addDataLayer({
                        event: "popup_click",
                        click_text: `${alertData?.descriptionText}`,
                        click_url: `${alertData?.ctaUrl}`,
                        page_title: document.title,
                      });
                    }}
                  >
                    {alertData.ctaLabel || "View Details"}
                  </Link>
                )}
                <button
                  className="bg-transparent pl-0 notificationclose ml-[4px]"
                  onClick={handleClick}
                  aria-label="Close alert"
                >
                  <Text
                    as="span"
                    className="pl-[0px] text-brandWhite icon-close"
                  ></Text>
                </button>
              </Box>
            </Box>
          </Columns>
        </Row>
      </SiteContainer>
    </Box>
  );
}